export function groupArrayItems(arrayOfObjects, leftGroupValue) {
  const leftGroupIndex = leftGroupValue + 1;
  const leftGroupItem = arrayOfObjects.find(item => item.id === leftGroupIndex);

  if (!leftGroupItem) {
    // Handle cases where the specified value is not found in the array of objects
    return arrayOfObjects;
  }

  const rightGroup = arrayOfObjects.filter(item => item.id !== leftGroupIndex);

  return [leftGroupItem, rightGroup.length === 1 ? rightGroup[0] : rightGroup];
}


export function findMenuItem(array, urlPath) {
  let foundItem = null;

  for (const item of array) {
      if (item.url === urlPath) {
          foundItem = item;
          break;
      } else if (urlPath.includes(item.url) && !foundItem) {
          foundItem = item;
          // break;
      } 
  }

  if (!foundItem) {
    foundItem = array[0];
}

 

  return foundItem;
}




  


  